const similarAddressFields = (addressTypes, addressIndex) => {
  return addressTypes.map((type) => {
    const index = !isNaN(addressIndex) ? addressIndex : "";

    return [
      {
        fieldId: `streetAddress`,
        fieldLabel: "Address",
        required: true,
        length: 4,
        placeHolder: "5985 State Bridge Rd",
        fieldType: "text",
        automationId: `${type.toLowerCase()}Address`,
        key: `streetAddress_${type.toLowerCase()}${index}`,
      },
      {
        fieldId: "suiteUnitFloor",
        fieldLabel: "Unit",
        length: 1,
        required: false,
        placeHolder: "11",
        fieldType: "text",
        automationId: `${type.toLowerCase()}Suite`,
        key: `suiteUnitFloor_${type.toLowerCase()}${index}`,
      },
      {
        fieldId: "cityShipping",
        fieldLabel: "City",
        length: 2,
        required: true,
        placeHolder: "Duluth",
        fieldType: "text",
        disabled: "disabled",
        automationId: `${type.toLowerCase()}CityShipping`,
        key: `cityShipping_${type.toLowerCase()}${index}`,
        disabled: true,
      },
      {
        fieldId: "state",
        fieldLabel: "State/Province",
        length: 2,
        maxLength: 2,
        required: true,
        placeHolder: "GA",
        fieldType: "text",
        automationId: `${type.toLowerCase()}State`,
        key: `state_${type.toLowerCase()}${index}`,
        disabled: true,
      },
      {
        fieldId: "zipCode",
        fieldLabel: "Zip",
        length: 2,
        required: true,
        placeHolder: "30097",
        fieldType: "text",
        automationId: `${type.toLowerCase()}ZipCode`,
        key: `zipCode_${type.toLowerCase()}${index}`,
        disabled: true,
      },
      {
        fieldId: "country",
        fieldLabel: "Country",
        length: 1,
        maxLength: 2,
        required: true,
        placeHolder: "US",
        fieldType: "text",
        automationId: `${type.toLowerCase()}Country`,
        key: `country_${type.toLowerCase()}${index}`,
        disabled: true,
      },
    ];
  });
};

export const shippingLocationAddressFields = () =>
  similarAddressFields(["shipping"]);
